module.exports = __webpack_public_path__ + "img/hr-pipe-corner-down-right.cbdf4314.png";